<template lang="pug">
  span(v-if="isNisfaSendEnabled")
    button.btn(:disabled="disabled",
      :class="'btn-' + btnLevel",
      type="button",
      @click.prevent="checkedItems.length ? modalConf = true : modalNoItem = true",
      data-testid="-btn-nisfa") SFAに送る

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    portal(to="modal")
      //- 未選択
      app-modal(v-model="modalNoItem" type="info")
        template(slot="title") 未選択
        h4 名刺を1件以上選択してください。

      //- NISFA連携確認
      app-modal(v-model="modalConf" type="primary")
        template(slot="title") 確認
        template(v-if="isBulk")
          h4 検索結果の名刺情報をSales Force Assistantへ送ります。よろしいですか？
          ul
            li 検索された人物の最新名刺情報を送ります。
            li 公開されている人物の最新名刺が対象です。
            li 対象が100件より多い場合は送信できません。
        template(v-else)
          h4 この人物の最新名刺情報をSales Force Assistantへ送ります。よろしいですか？
        template(slot="footer", slot-scope="{close}")
          button.btn.btn-primary(type="submit" @click.prevent="sendNisfa")
            span(v-if="isExecuting"): i.fa.fa-spinner.fa-pulse
            span(v-else) 送る
          button.btn.btn-default(type="button" @click.prevent="close") キャンセル

      //- NISFA連携完了
      app-modal(v-model="modalSuccess" type="default")
        h4(v-if="isBulk") 検索結果の名刺情報をSales Force Assistantへ送りました。
        h4(v-else) この人物の最新名刺情報をSales Force Assistantへ送りました。
        p 連携の結果はお知らせでお伝えします。しばらくしてから
          router-link(:to="{name: 'information'}" target="_blank") お知らせ一覧
          | をご確認ください。
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const PvNisfaIntegrationRepository = RepositoryFactory.get('pvnisfaintegration')

export default {
  name: 'FuncSendToNisfa',
  components: { AppModal },
  props: {
    isBulk: { type: Boolean, required: false, default: false },
    checkedItems: { type: Array, required: false, default: function () { return [] } },
    btnLevel: { type: String, required: false, default: 'default', validate (value) { return this.isIncludes(['default', 'primary'], value) } }
  },
  data: function () {
    return {
      modalNoItem: false,
      modalConf: false,
      modalSuccess: false,
      isExecuting: false
    }
  },
  computed: {
    disabled () {
      // 全ページ選択モードの時は利用しない
      return this.$parent.isAllPagesChecked
    },
    /**
     * NISFA機能を使えるかどうか
     * @return {boolean} 検索結果があり、連携設定のすべてがtrue
     */
    isNisfaSendEnabled () {
      // 詳細画面で非公開名刺の場合はfalse
      const person = (this.checkedItems[0] && this.checkedItems[0].person) || {}
      if (!this.isBulk && person.openflag !== this.app_flag.ON) {
        return false
      }
      return this.isNisfaPvEnabled
    }
  },
  methods: {
    /**
     * NISFAへ検索結果の名刺を送信する
     */
    sendNisfa () {
      const vm = this
      // this.clearErrorMessages()

      let sidPersons = this.checkedItems.map(item => item.sid_person)

      this.isExecuting = true
      PvNisfaIntegrationRepository.execute(sidPersons)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.modalConf = false
            vm.modalSuccess = true
          }
          // else {
          //   const res = vm.getApiData(response).data
          //   console.log(res)
          // }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || 'SFAに送ることができませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        .finally(function () {
          vm.isExecuting = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncSendToNisfa.vue